<template>
    <div class="time-period is-clearfix" :class="{ 'error' : error.length !== 0 }">
        <div class="flatpickr-wrapper">
            <datepicker class="time-period-input" :config="datepickerOptionsStart" v-model="date_start" @click.native="openDate('Start')">
                <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
            </datepicker>
        </div>
        <span class="time-period-spacer">{{ $t('seasons.until') }}</span>
        <div class="flatpickr-wrapper">
            <datepicker class="time-period-input is-expanded" :config="datepickerOptionsEnd" v-model="date_end" @click.native="openDate('End')">
                <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
            </datepicker>
        </div>
        <a v-if="deleteable" class="button time-period__delete" @click="removePeriod()">
            <i class="fa fa-trash" aria-hidden="true"></i>
        </a>
    </div>
</template>

<script>
    import Datepicker from 'vue-bulma-datepicker';
    import { AppModel } from '../../../models';
    import { Tracking } from '../../../utils';

    export default {
        name: 'time-period',
        components: {
            Datepicker,
        },

        props: {
            value: {
                type: Object,
                'default': () => ([]),
            },
            error: {
                type: Array,
                'default': () => ([]),
            },
            deleteable: {
                type: Boolean,
                'default': true
            }
        },

        data() {
            return {
                date_start: this.value.date_start,
                date_end: this.value.date_end,
                datepickerOptionsStart: AppModel.getDatepickerOptions(
                    {defaultDate: this.value.date_start}
                ),
                datepickerOptionsEnd: AppModel.getDatepickerOptions(
                    {defaultDate: this.value.date_end}
                ),
            };
        },

        watch: {
            'date_start': function(newValue, oldValue) {
                this.value.date_start = newValue;
                this.$emit('input', this.value);
            },
            'date_end': function(newValue, oldValue) {
                this.value.date_end = newValue;
                this.$emit('input', this.value);
            },
        },

        methods: {
            removePeriod() {
                this.$emit('del');
            },

            openDate(type) {
                Tracking.trackEvent('Season', 'timePeriod', `open${type}`, null);
            }
        },
    };
</script>

<style lang="scss">
    @import 'time-period.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/time-period/timePeriod.vue